/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable max-len */
import React from 'react';
import { Container, Content } from './styles';

export const Footer = () => {
  return (
    <Container>
      <Content>
        <div className="record">
          <a
            href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=913101125727109138-SAIC_SHOW_1000009131011257271091381742204876891&signData=MEUCID0w2F8fLaUhCuQCGH9lgjgaI0nAStqHsGJ0bye1FTRUAiEAlUqKoyCnrwMycWh5pSgS7XLXP8bhivu3si876BV3mWc="
            target="_blank"
          >
            <img src="https://gw.alicdn.com/imgextra/i2/O1CN01gUi0Fn1IOSi8HV4mE_!!6000000000883-2-tps-60-60.png" alt="" />
          </a>
          <img src="https://img.alicdn.com/tfs/TB1WvYPX2WG3KVjSZFPXXXaiXXa-40-40.png" />
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=31010402335048" rel="noreferrer" target="_blank">沪公网安备31010402335048号</a>
          <img src="https://gw.alicdn.com/tfs/TB1GxwdSXXXXXa.aXXXXXXXXXXX-65-70.gif" alt="" />
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">沪ICP备11014111号-15</a>
        </div>
      </Content>
    </Container>
  );
};
